import React from "react";
import { LayoutPicker } from "./LayoutPicker";
import { useNodeActions } from "../../hook/useNodeActions";
import { usePicker } from "../Elements/PickerContext";


export function AddContainerZone({ sectionId, index,page, setPage }) {
  const { activePicker, setActivePicker } = usePicker();
  const { addContainerFromTemplateAction } = useNodeActions(page, setPage);

  const key = `${sectionId}-container-${index}`;
  const isActive = activePicker === key;

  function onSelect(template) {
    addContainerFromTemplateAction(sectionId, template.columns, index);
    setActivePicker(null);
  }

  return (
    <div   
      style={{
        width:"100%",
        height: "20px",
        background: isActive ? "#1A73E8" : "transparent",
        margin: "12px 0",
        cursor: "pointer",
        position: "relative",
      }}
        onMouseEnter={(e) => {
        e.currentTarget.style.background = "#1A73E8";
        e.currentTarget.style.height = "20px";
        
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.height = "20px";
        
      }}  
      onClick={(e) => {
        e.stopPropagation();
        setActivePicker(isActive ? null : key);
      }}
    >
      {isActive && (
        <LayoutPicker onSelect={onSelect} />
      )}
    </div>
  );
}
